import { render } from "./ShowUser.vue?vue&type=template&id=8a1e3678&scoped=true"
import script from "./ShowUser.vue?vue&type=script&lang=js"
export * from "./ShowUser.vue?vue&type=script&lang=js"

import "./ShowUser.vue?vue&type=style&index=0&id=8a1e3678&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a1e3678"]])

export default __exports__